export enum HittersRoutes {
  CreateHitter = 'create-hitter',
  DeleteHitters = 'delete-hitters',
  DeleteSessions = 'delete-sessions',
  GetLatestSessionByHitterID = 'get-latest-session-by-hitter-id',
  GetHit = 'get-hit',
  GetHitByFire = 'get-hit-by-fire',
  GetHitter = 'get-hitter',
  GetHitters = 'get-hitters',
  GetProfileHits = 'get-profile-hits',
  GetSessionHits = 'get-session-hits',
  GetSessionSummaries = 'get-session-summaries',
  UpdateHit = 'update-hit',
  UpdateHits = 'update-hits',
  UpdateHitter = 'update-hitter',
  UploadCsv = 'upload-csv',
  UploadHitterAvatar = 'upload-hitter-avatar',
  UpsertDetectionIssue = 'upsert-detection-issue',
  UpsertMetadata = 'upsert-metadata',
}
